/**
 * Bezpieczne Leaflet.invalidateSize — unika wyjątku przy odczycie _leaflet_pos,
 * gdy mapa jest w trakcie unmountu, _mapPane już usunięty, albo kontener nie jest w DOM.
 *
 * @param {import('leaflet').Map | null | undefined} map
 * @param {{ animate?: boolean; pan?: boolean; debounceMoveend?: boolean }} [options] — domyślnie pan: false (bez _rawPanBy)
 */
export function safeInvalidateMapSize(map, options = {}) {
  if (!map || typeof map.invalidateSize !== 'function') return;
  const el = map.getContainer?.();
  if (!el || !el.isConnected) return;
  // Leaflet usuwa _mapPane w remove(); bez tego invalidateSize → _rawPanBy → TypeError
  if (!map._mapPane) return;

  const opts =
    options && typeof options === 'object'
      ? { animate: false, pan: false, ...options }
      : { animate: false, pan: false };

  try {
    map.invalidateSize(opts);
  } catch {
    /* np. usunięty _mapPane w tym samym ticku co rAF */
  }
}
